import { aa_1_slidedeck } from './SL61200Sprint01'
import { aa_2_slidedeck } from './SL61200Sprint02'
import { aa_3_slidedeck } from './SL61200Sprint03'
import { aa_4_1of1_PAaA } from './SL62100Sprint04'
import { aa_6_slidedeck } from './SL62100Sprint06'
import { aa_7_slidedeck } from './SL62100Sprint07'

import { tUnderConstruction } from './SL00000Sprint00'

const uCSD = [ tUnderConstruction ] // A uCSD is an array of one tUnderConstruction slide.
const uCM = [ uCSD, uCSD, uCSD, uCSD, uCSD, uCSD ] // A uCM is an array of 6 class sessions each containing a UCSDs.

// The se_slidedeck structure is a multiple dimensional array of slidesdecks consisting of 8 modules of 6 potential 
// classes each. Each slidedeck is an array of 1 to n slides. 
export const aa_slidedeck = [ aa_1_slidedeck, aa_2_slidedeck, aa_3_slidedeck, aa_4_1of1_PAaA, uCM, aa_6_slidedeck, aa_7_slidedeck, uCM ]